<template>
  <div class="progress">
    <span
      :class="[
        'progress__label',
        isPlaylistCompleted && 'progress__label--complete',
      ]"
    >
      {{ playlistStatusLabel }}
    </span>
    <span class="progress__percentage">
      {{ percentage ? `${percentage}% complete` : '' }}
    </span>
  </div>
</template>

<script>
export default {
  name: 'PlaylistProgress',
  props: {
    value: {
      type: Number,
      required: true,
    },
  },
  computed: {
    percentage() {
      const value = this.value * 100
      try {
        return Math.floor(value)
      } catch (err) {
        return 0
      }
    },
    isPlaylistCompleted() {
      return this.value === 1
    },
    playlistStatusLabel() {
      if (this.isPlaylistCompleted) return 'Playlist complete!'
      return this.value === 0 ? 'Not started' : 'In progress'
    },
  },
}
</script>

<style lang="scss" scoped>
.progress {
  display: flex;
  flex-direction: column;
  justify-content: center;
  &__label {
    &--complete {
      color: var(--positive-light);
    }
  }
  &__percentage {
    color: var(--light-blue-gray);
  }
}
</style>
